/* ============================================================
   v20 - JEDEN PORTFEL W KOSZYKU (Apple Pay ALBO Google Pay)

   Problem:
   Na stronie produktu przycisk robi filtr `form | payment_button`
   (element <shopify-accelerated-checkout>) i Shopify pokazuje tam
   DOKLADNIE JEDEN portfel pod urzadzenie.
   W koszyku jest inny element - <shopify-accelerated-checkout-cart>
   z content_for_additional_checkout_buttons - i ten dostaje w
   atrybucie `wallet-configs` LISTE portfeli. Na iPhone lista to
   [apple_pay, google_pay], wiec w popupie koszyka pokazywaly sie
   dwa przyciski naraz. Na Androidzie lista ma tylko google_pay,
   dlatego tam problemu nie bylo widac.

   Rozwiazanie:
   Zanim element sie wyrenderuje, przycinamy `wallet-configs` do
   jednego portfela:
     - Apple Pay dziala na tym urzadzeniu -> zostaje apple_pay
     - w kazdym innym przypadku           -> zostaje google_pay

   Dlaczego pytamy ApplePaySession, a nie User Agenta:
   ApplePaySession istnieje tylko w przegladarkach Apple, a
   canMakePayments() mowi, czy urzadzenie faktycznie obsluguje
   Apple Pay. Gdybysmy zgadywali po nazwie przegladarki, na
   iPhone bez Apple Pay zostalby przyciety Google Pay i klient
   nie zobaczylby ZADNEGO przycisku szybkiej platnosci.

   Dlaczego MutationObserver, a nie skrypt inline w sekcji:
   popup koszyka jest przerysowywany przez Section Rendering API
   (cart.js wstawia nowy HTML przez innerHTML). Skrypty wstawione
   w ten sposob sie NIE wykonuja, wiec po kazdej zmianie ilosci
   wrocilyby dwa przyciski. Observer lapie kazdy nowy element.

   Nowy element tworzymy od zera i podmieniamy stary, bo web
   component czyta konfiguracje przy podlaczeniu do DOM.

   Bezpiecznik: jesli danych nie da sie odczytac (Shopify zmieni
   format), nie ruszamy niczego - zostaje domyslne zachowanie.
   ============================================================ */
(function () {
  'use strict';

  var SEL = 'shopify-accelerated-checkout-cart';

  function appleAvailable() {
    try {
      return !!(window.ApplePaySession &&
        typeof window.ApplePaySession.canMakePayments === 'function' &&
        window.ApplePaySession.canMakePayments());
    } catch (e) {
      return false;
    }
  }

  function trim(el) {
    if (!el || el.getAttribute('data-sw-wallet') === 'done') return;

    var raw = el.getAttribute('wallet-configs');
    if (!raw) { el.setAttribute('data-sw-wallet', 'done'); return; }

    var list;
    try { list = JSON.parse(raw); } catch (e) { return; }
    if (!Array.isArray(list) || list.length < 2) {
      el.setAttribute('data-sw-wallet', 'done');
      return;
    }

    var want = appleAvailable() ? 'apple_pay' : 'google_pay';
    var keep = list.filter(function (w) { return w && w.name === want; });
    if (!keep.length) keep = [list[0]];
    if (keep.length === list.length) {
      el.setAttribute('data-sw-wallet', 'done');
      return;
    }

    var fresh = document.createElement(el.tagName.toLowerCase());
    Array.prototype.forEach.call(el.attributes, function (a) {
      fresh.setAttribute(a.name, a.value);
    });
    fresh.setAttribute('wallet-configs', JSON.stringify(keep));
    fresh.setAttribute('data-sw-wallet', 'done');
    if (el.parentNode) el.parentNode.replaceChild(fresh, el);
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    Array.prototype.forEach.call(root.querySelectorAll(SEL), trim);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!node || node.nodeType !== 1) continue;
          if (node.matches && node.matches(SEL)) trim(node);
          else scan(node);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
